import { RouteConstants } from "src/app/share/constants/routes.constants";
import { environment } from "src/environments/environment";

export function adminSideBarList(envType: string = 'SDEX') {
  let list: any[] = [
    {
      label: 'Dashboard',
      roles: '',
      routerLink: RouteConstants.AdminDashboard,
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
    },
    {
      label: 'Organisations',
      roles: 'company.view',
      routerLink: '/admin/sdex/company',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
    },
    {
      label: 'Roles',
      roles: 'role.view',
      routerLink: '/roles/role-list',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
    },
    {
      label: 'Users',
      roles: 'user.view',
      routerLink: '/admin/sub-company-users',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
    },
    {
      label: 'Licenses',
      roles: 'licenses.create',
      routerLink: '/admin/license',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
    },
    {
      label: 'IDP Playground',
      roles: 'idp-playground.allow',
      modules: 'idp-playground.enabled',
      routerLink: '/ocr-playground',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
    },
    {
      label: 'API Key',
      routerLink: RouteConstants.ApiKey,
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/api-key.svg'
    }
  ]
  if (envType === 'SDEX') {
    list = list.concat([
      {
        label: 'LR Templates',
        roles: 'lr.assign',
        routerLink: '/admin/admin-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'IBA',
        routerLink: '/iba',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/bank.svg'
      }]
    )
  }
  if (envType !== 'CLMS') {
    list.push({
      label: 'Preferences',
      routerLink: '/preferences',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
    });
  }
  return list;
}

function checkDashboardCondition(userDetails: any, authService: any, materialEnabled: any = false): boolean {
  let noEsignPermission = userDetails?.disabledPermissions?.includes('e-sign-details');
  if (materialEnabled && noEsignPermission) {
    return true;
  }
  let hasDocumentAccess = authService.documentVaultAccess();
  if (!hasDocumentAccess) {
    return false;
  }
  if (userDetails?.documentVault?.isExists || materialEnabled) {
    if (noEsignPermission ||
      (!noEsignPermission && userDetails?.eSignSelfLink)) {
      return true;
    } else if (!noEsignPermission && userDetails?.eSignSelfLink === undefined) {
      return false;
    }
  }
  return false;
}

export function companySideBarList(envType: string, isAdmin: boolean, isPrimary: boolean, userDetails: any, authService: any, materialEnabled: boolean, tgsrtcEnabled: boolean, entityType: any,isDamsHost: boolean,prefs: any = {}) {
  const docVaultPrefs = prefs?.documentVault || {};
  const isBranchPreferenceEnabled = prefs?.branchPreference?.enabled || false;
  const studentCertEnabled = !!docVaultPrefs?.studentCertificate;
  const sscStudentCertEnabled = !!docVaultPrefs?.sscStudentCertificate;
  const biecStudentCertEnabled = !!docVaultPrefs?.bieStudentCertificate;
  const bieDesignation = userDetails?.bieDesignation;
  let bieUserType: string;
  if (bieDesignation === 'Level1') {
    bieUserType = 'L1';
  } else if (bieDesignation === 'Level2') {
    bieUserType = 'L2';
  } else {
    const company = userDetails?.assignedTo?.[0]?.company?._id;
    const rootCompany = userDetails?.rootCompany;
    bieUserType = (company && rootCompany && company !== rootCompany) ? 'L3' : 'general';
  }
  const hideBieAdminItems = biecStudentCertEnabled && bieUserType !== 'general';

  if (envType === 'SDEX' || !envType) {
    let sdexSidebar = [
      {
        label: 'Dashboard',
        roles: '',
        routerLink: '/admin/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'Packages',
        roles: 'package.view',
        modules: 'package.enabled',
        routerLink: '/packages/incoming',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Packages.svg'
      },
      {
        label: ' Document Vault',
        roles: 'document.view',
        modules: 'documentVault.enabled',
        routerLink: 'document-vault',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      },
      {
        label: 'Network',
        roles: '',
        modules: 'company-contacts.enabled',
        routerLink: '/admin/contact-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
      },
      {
        label: 'Search Company',
        roles: '',
        modules: 'ekyc.enabled',
        routerLink: RouteConstants.EKycSearchList,
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
        addBorder: true
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
      },
      {
        label: 'Org. Structure',
        roles: 'company.view',
        modules: 'organizationStructure.enabled',
        routerLink: '/organization-structure',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'LR Templates',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/admin/company-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'LR List',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/lr-generation/generated-lrs',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-list.svg'
      },
      {
        label: 'Global Settings',
        roles: true,
        routerLink: '/admin/company-settings',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
      },
      {
        label: 'e-Way Bill',
        roles: 'ewaybill.view',
        modules: 'package.eWaybill',
        routerLink: '/eway-bill/credentials',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lock.svg'
      },
      {
        label: 'e-Invoice',
        roles: 'einvoice.view',
        modules: 'package.eInvoice',
        routerLink: '/einvoice',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/invoice.svg'
      }];
    if (userDetails?.primary) {
      sdexSidebar.push({
        label: 'File Storage',
        roles: '',
        routerLink: '/admin/storage-credentials',
        modules: 'documentVault.externalStorage',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/storage-credentials.svg'
      });
    }
    return sdexSidebar;
  }
  else if (envType === 'DAMS') {
    const isBhavya = Array.isArray(entityType) ? entityType.includes('bhavya') : entityType === 'bhavya';
    const allRoles = userDetails?.presentRoles || userDetails?.roles || [];
    const hasFullOrUploadAccess = allRoles.some((role: any) => 
      (role.permissions || []).some((permission: any) => 
        permission?.enabled === true
      )
    );
    const hasLimitedDocPermissions = allRoles.some((role: any) => 
      (role.permissions || []).some((permission: any) => 
        permission?.subPermissions?.['share-view'] === true || 
        permission?.subPermissions?.['file-view'] === true ||
        permission?.subPermissions?.['share-user'] === true ||
        permission?.subPermissions?.['folder-share'] === true ||
        permission?.subPermissions?.['folder-create'] === true ||
        permission?.subPermissions?.['folder-edit'] === true ||
        permission?.subPermissions?.['folder-delete'] === true ||
        permission?.subPermissions?.['file-upload'] === true ||
        permission?.subPermissions?.['file-edit'] === true ||
        permission?.subPermissions?.['file-delete'] === true ||
        permission?.subPermissions?.['file-transfer'] === true
      )
    );
    const hideDashboardAndMasterData = hasLimitedDocPermissions && !hasFullOrUploadAccess;
    let dashboardRouterLink = '/admin/dashboard';
    if (isBhavya) {
      dashboardRouterLink = '/patient-dashboard';
    } else if (checkDashboardCondition(userDetails, authService, materialEnabled)) {
      dashboardRouterLink = 'dams-dashboard';
    }

    if (environment?.["isRainbow"]) {
      let rainbowSidebar = [
        {
          label: 'Dashboard',
          skipAccess: true,
          routerLink: dashboardRouterLink,
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
        },
        {
          label: 'Org Structure',
          roles: 'company.view',
          routerLink: '/organization-structure',
          modules: 'organizationStructure.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
        },
        {
          label: 'Roles',
          roles: 'role.view',
          routerLink: '/roles/role-list',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
        },
        {
          label: 'Users',
          roles: 'user.view',
          routerLink: '/admin/sub-company-users',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
        },
        {
          label: 'MasterData',
          roles: 'document.view, workflow.view,workflow.delete,workflow.update,workflow.create',
          routerLink: '/lookup',
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
        },
        {
          label: 'Document Vault',
          roles: 'document.view',
          modules: 'documentVault.enabled',
          routerLink: 'document-vault',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
        },
        {
          label: 'Global settings',
          roles: '',
          modules: 'customUrl.customUrl',
          routerLink: '/admin/company-settings',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
        },
        {
          label: 'Notifications',
          skipAccess: true,
          routerLink: RouteConstants.AppNotifications,
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/notification.svg'
        },
        {
          label: 'Help',
          routerLink: RouteConstants.help,
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/user-unverified-white.svg'
        }
      ];
      if (hideDashboardAndMasterData) {
        rainbowSidebar = rainbowSidebar.filter((item: any) => item.label !== 'Dashboard' && item.label !== 'MasterData');
      }
      return rainbowSidebar;
    }

    const damsSidebar: any[] = [
      ...(!hideBieAdminItems ? [
      ...(materialEnabled ? [
        {
          label: 'Dashboard',
          roles: '',
          skipAccess: true,
          modules: 'material.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg',
          subItems: [
            { label: 'Storage', routerLink: 'dams-dashboard', roles: '', skipAccess: true, modules: 'material.enabled', hideList: true },
            { label: 'Web Register', routerLink: 'material-register/dashboard', roles: '', skipAccess: true, modules: 'material.enabled', hideList: true },
            ...((isAdmin || userDetails?.primary) ? [
              { label: 'Performance KPI', routerLink: 'material-register/kpi', roles: '', skipAccess: true, modules: 'material.enabled', hideList: true }
            ] : []),
            ...(userDetails?.primary ? [
              { label: 'Billing', routerLink: 'material-register/billing', roles: '', skipAccess: true, modules: 'material.enabled', hideList: true }
            ] : [])
          ]
        }
      ] : [
        {
          label: 'Dashboard',
          skipAccess: true,
          routerLink: dashboardRouterLink,
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
        }
      ]),

      {
        label: 'Org. Structure',
        roles: 'company.view',
        routerLink: '/organization-structure',
        modules: 'organizationStructure.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      ] : []),
      {
        label: 'Business Partners',
        roles: 'mr-masterdata.view',
        modules: 'material.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/icons8-partnership-100.png',
        subItems: [
          {
            label: 'Customers',
            roles: 'mr-outbound.view',
            routerLink: 'shipment/customers',
            modules: 'material.enabled',
            hideList: true,
          },
          {
            label: 'Suppliers',
            roles: 'mr-inbound.view',
            routerLink: 'shipment/suppliers',
            modules: 'material.enabled',
            hideList: true,
          },
          {
            label: 'Scrap Buyers',
            roles: 'mr-scrap.view',
            routerLink: 'shipment/scrap-buyers',
            modules: 'material.enabled',
            hideList: true,
          },
          {
            label: 'Transporters',
            roles: 'mr-inbound.view,mr-outbound.view',
            routerLink: 'shipment/transportes',
            modules: 'material.enabled',
            hideList: true,
          },
        ]
      },
      {
        label: 'Material Register',
        roles: 'mr-inbound.view,mr-outbound.view,mr-scrap.view',
        routerLink: RouteConstants.MaterailRegister,
        modules: 'material.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'Workflow Vault',
        roles: 'workflow-document.view',
        routerLink: RouteConstants.WorkflowDocument,
        modules: 'workFlow.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },

      {
        label: 'Network',
        roles: 'guest-company.view',
        routerLink: '/contacts',
        modules: 'contractManagementSystem.enabled',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg'
      },
      {
        label: 'Contracts',
        roles: 'contracts.view',
        routerLink: 'contracts',
        modules: 'contractManagementSystem.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
      },
      {
        label: 'LR Templates',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/admin/company-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'LR List',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/lr-generation/generated-lrs',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-list.svg'
      },
      {
        label: 'Preferences',
        roles: '',
        routerLink: 'cms-preference',
        modules: 'contractManagementSystem.enabled',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
      },
      {
        label: 'Certificates',
        roles: 'certificates',
        routerLink: 'student-file',
        modules: 'documentVault.studentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'SSC Certificates',
        routerLink: RouteConstants.SSCCertificates,
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      },
      {
        label: 'SSC Dashboard',
        routerLink: RouteConstants.SSCDashboard,
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'SSC Students',
        routerLink: 'student-list',
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'Students List',
        routerLink: 'student-list',
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.studentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'BIE Certificates',
        routerLink: RouteConstants.BIECertificates,
        roles: 'bie-certificate.view,bie-certificate.edit',
        modules: 'documentVault.bieStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'BIE Dashboard',
        routerLink: RouteConstants.BIEDashboard,
        roles: 'bie-certificate.view,bie-certificate.edit',
        modules: 'documentVault.bieStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'BIE Students',
        routerLink: RouteConstants.BIEStudentsList,
        roles: 'bie-certificate.view,bie-certificate.edit',
        modules: 'documentVault.bieStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
    ]
    if (entityType?.length) {
      const entities = Array.isArray(entityType) ? entityType : [entityType];
       if (entities.includes('beneficiary')) {
        damsSidebar.push({
          label: 'Beneficiary',
          routerLink: RouteConstants.beneficiaryReports,
          roles: '',
          modules: 'serviceType.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });       
      }
      if (entities.includes('medical')) {
        damsSidebar.push({
          label: 'Patient Reports',
          routerLink: RouteConstants.HospitalManagement,
          roles: '',
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });
        damsSidebar.push({
          label: 'Master Data',
          roles: 'document.view',
          routerLink: '/lookup',
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
        });
      }
      if (entities.includes('bhavya')) {
        damsSidebar.push({
          label: 'Patient',
          routerLink: RouteConstants.PatientDetails,
          roles: '',
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });
      }
      if (entities.includes('waterBoard')) {
        damsSidebar.push(
          {
            label: 'Water Board',
            roles: '',
            modules: 'documentVault.enabled',
            hideList: true,
            imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg',
            subItems: [
              { label: 'HMWSSB Register', routerLink: RouteConstants.WaterBoardEmployeeRegister, roles: '', modules: 'documentVault.enabled', hideList: true },
              { label: 'AI Assistant', routerLink: RouteConstants.Chatbot, roles: '', modules: 'documentVault.enabled', hideList: true},
            ]
          }
        );
      }
      if (entities.includes('nicdc')) {
        damsSidebar.push({
          label: 'AI Assistant',
          routerLink: RouteConstants.Chatbot,
          modules: 'documentVault.enabled',
          roles: '',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/chatbot.png'
        });
      }
      if (entities.includes('tgsrtc') || tgsrtcEnabled) {
        damsSidebar.push({
          label: 'TGSRTC Register',
          routerLink: RouteConstants.EmployeeRegister,
          roles: '',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });
      }
    }
    let entitiesList: string[] = [];
    if (Array.isArray(entityType)) {
      entitiesList = entityType;
    } else if (typeof entityType === 'string') {
      entitiesList = entityType.split(',');
    }
    const hasMultipleEntities = entitiesList.length > 1;
    if (
      !hasMultipleEntities &&
      !tgsrtcEnabled &&
      (
        !entityType ||
        entitiesList.includes('waterBoard') ||
        entitiesList.includes('medical') ||
        entitiesList.includes('bhavya')
      ) &&
      !sscStudentCertEnabled &&
      !studentCertEnabled &&
      !biecStudentCertEnabled
    ) {
      damsSidebar.push({
        label: 'Document Vault',
        roles: 'document.view',
        routerLink: 'document-vault',
        modules: 'documentVault.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      });
    }
    if ((userDetails.primary || userDetails.rootCompany === userDetails.company) || (isAdmin && isBranchPreferenceEnabled)) {
      damsSidebar.push({
        label: 'API Key',
        roles: '',
        routerLink: RouteConstants.ApiKey,
        modules: 'apiKey.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/api-key.svg'
      });
      if (!isDamsHost) {
        damsSidebar.push({
          label: 'Global Settings',
          roles: '',
          modules: 'customUrl.customUrl',
          routerLink: '/admin/company-settings',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
        });
      }
      if (userDetails?.primary) {
        damsSidebar.push({
          label: 'File Storage',
          roles: '',
          routerLink: '/admin/storage-credentials',
          modules: 'documentVault.externalStorage',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/storage-credentials.svg'
        });
      }
    }

    if (['APBoard', 'Board'].includes(userDetails?.assignedTo[0]?.company?.enrollmentType)) {
      damsSidebar.push({
        label: 'Certificates',
        roles: '',
        routerLink: 'certificate-generation/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      });
    }
    const showMasterData = (!materialEnabled && !tgsrtcEnabled && !entityType?.length && !sscStudentCertEnabled && !studentCertEnabled && !biecStudentCertEnabled) || entityType?.includes('bhavya');
    if (showMasterData) {
      damsSidebar.push({
        label: 'Bunch',
        roles: 'document.view',
        routerLink: RouteConstants.BunchList,
        modules: 'documentVault.ocr',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/invoice.svg'
      })
      damsSidebar.push({
        label: 'Master Data',
        roles: 'document.view, workflow.view,workflow.delete,workflow.update,workflow.create',
        routerLink: '/lookup',
        modules: 'documentVault.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
      });
    }

    if (userDetails?.guestCompany && !userDetails?.company) {
      return [
        {
          label: 'Contracts',
          skipAccess: true,
          routerLink: 'contracts',
          modules: 'contractManagementSystem.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
        },
      ]
    }

    if (envType === 'DAMS') {
      if (!hideBieAdminItems) {
        damsSidebar.push({
          label: 'Notifications',
          skipAccess: true,
          routerLink: RouteConstants.AppNotifications,
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/notification.svg'
        });
      }
      damsSidebar.push(
      {
        label: 'Help',
        routerLink: RouteConstants.help,
        modules: 'material.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/user-unverified-white.svg'
      },
      {
        label: 'IDP Playground',
        roles: 'idp-playground.allow',
        modules: 'idp-playground.enabled',
        routerLink: '/ocr-playground',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
      },
      {
        label: 'Network',
        roles: '',
        modules: 'company-contacts.enabled',
        routerLink: '/admin/contact-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
      },
      {
        label: 'Packages',
        roles: 'package.view',
        modules: 'package.enabled',
        routerLink: '/packages/incoming',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Packages.svg'
      },
      {
        label: 'Search Company',
        roles: '',
        modules: 'ekyc.enabled',
        routerLink: RouteConstants.EKycSearchList,
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
      },
      {
        label: 'e-Way Bill',
        roles: 'ewaybill.view',
        modules: 'package.eWaybill',
        routerLink: '/eway-bill/credentials',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lock.svg'
      },
      {
        label: 'e-Invoice',
        roles: 'einvoice.view',
        modules: 'package.eInvoice',
        routerLink: '/einvoice',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/invoice.svg'
      }
    );
    }

    if (hideDashboardAndMasterData) {
      return damsSidebar.filter((item: any) => item.label !== 'Dashboard' && item.label !== 'Master Data' && item.label !== 'MasterData');
    }
    return damsSidebar;
  }

  else if (envType === 'CLMS') {
    if (userDetails?.guestCompany && !userDetails?.company) {
      return [
        {
          label: 'Contracts',
          skipAccess: true,
          routerLink: 'contracts',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
        },
      ]
    }
    return [
      {
        label: 'Dashboard',
        roles: '',
        routerLink: '/admin/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'Org. Structure',
        roles: 'company.view',
        routerLink: '/organization-structure',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg',
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg',
        addBorder: true
      },

      {
        label: 'Network',
        roles: 'guest-company.view',
        routerLink: '/contacts',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg'
      },
      {
        label: 'Contracts',
        roles: 'contracts.view',
        routerLink: 'contracts',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
      },
      {
        label: 'Preferences',
        roles: true,
        routerLink: 'cms-preference',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
      },
      {
        label: 'Global Settings',
        roles: true,
        routerLink: '/admin/company-settings',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
      },
    ]
  }
  return [];
}
